import { FilterField, FilterInputType } from 'layout/TableLayout/types.d';
import { GRADE_OPTIONS } from 'constants/global';
import VALIDATION from 'utils/validation';

const COMPETENCY_MAP_FILTERS: FilterField[] = [
  {
    name: 'createdAt',
    type: FilterInputType.DATE,
    title: 'Дата создания',
  },
  {
    name: 'fullCompanyName',
    type: FilterInputType.TEXT,
    title: 'Полное название компании',
    rules: VALIDATION.companyName,
  },
  {
    name: 'title',
    type: FilterInputType.TEXT,
    title: 'Название',
    rules: VALIDATION.competencyMapTitle,
  },
  {
    name: 'grades',
    type: FilterInputType.AUTOCOMPLETE,
    title: 'Грейд',
    options: GRADE_OPTIONS,
  },
];

export default COMPETENCY_MAP_FILTERS;
